module.exports = __webpack_public_path__ + "static/img/propaganda-5.5a41b82a.jpeg";